const DEFAULT_ALLOWED_RELAY_HOSTS = [
  'claude.ai',
  'www.claude.ai',
  'claude.com',
  'www.claude.com',
  'chat.openai.com',
  'chatgpt.com',
  'www.chatgpt.com',
];
const CLAUDE_DESKTOP_REDIRECT_PROTOCOL = 'claude:';
const CLAUDE_DESKTOP_REDIRECT_HOST = 'claude.ai';
const CLAUDE_DESKTOP_REDIRECT_PATH = '/mcp-auth-callback/sdk';

export function getMcpOauthRelayAllowedHosts(rawValue = process.env.REACT_APP_MCP_OAUTH_RELAY_ALLOWED_HOSTS) {
  const parsed = (rawValue || '')
    .split(',')
    .map((item) => item.trim().toLowerCase())
    .filter((item) => item.length > 0);

  return new Set(parsed.length > 0 ? parsed : DEFAULT_ALLOWED_RELAY_HOSTS);
}

export function buildMcpOauthRelayRedirect(
  currentHref,
  rawAllowedHosts = process.env.REACT_APP_MCP_OAUTH_RELAY_ALLOWED_HOSTS
) {
  if (typeof currentHref !== 'string' || currentHref.trim().length === 0) {
    return null;
  }

  let currentUrl;
  try {
    currentUrl = new URL(currentHref);
  } catch {
    return null;
  }

  const params = currentUrl.searchParams;
  const targetRaw = params.get('mcp_oauth_redirect');
  if (!targetRaw) {
    return null;
  }

  const hasOAuthResponseParams =
    params.has('code') ||
    params.has('error') ||
    params.has('state');
  if (!hasOAuthResponseParams) {
    return null;
  }

  let relayTarget;
  try {
    relayTarget = new URL(targetRaw);
  } catch {
    return null;
  }

  const relayHostname = relayTarget.hostname.toLowerCase();
  // Claude Code uses http://localhost:<ephemeral-port>/callback while Codex
  // uses literal IPv4/IPv6 loopback callbacks. Keep this exact-host check so
  // lookalike domains such as localhost.example never enter the native relay.
  const isLoopback =
    (relayHostname === 'localhost' || relayHostname === '127.0.0.1' || relayHostname === '[::1]') &&
    relayTarget.username === '' &&
    relayTarget.password === '';
  const isSecureHostedCallback = relayTarget.protocol === 'https:';
  const isNativeLoopbackCallback = relayTarget.protocol === 'http:' && isLoopback;
  const isClaudeDesktopCallback =
    relayTarget.protocol === CLAUDE_DESKTOP_REDIRECT_PROTOCOL &&
    relayHostname === CLAUDE_DESKTOP_REDIRECT_HOST &&
    relayTarget.pathname === CLAUDE_DESKTOP_REDIRECT_PATH &&
    relayTarget.username === '' &&
    relayTarget.password === '' &&
    relayTarget.port === '' &&
    relayTarget.search === '' &&
    relayTarget.hash === '';

  if (!isSecureHostedCallback && !isNativeLoopbackCallback && !isClaudeDesktopCallback) {
    return null;
  }

  const allowedHosts = getMcpOauthRelayAllowedHosts(rawAllowedHosts);
  if (isSecureHostedCallback && !allowedHosts.has(relayHostname)) {
    return null;
  }

  const forwardedParams = new URLSearchParams(currentUrl.search);
  forwardedParams.delete('mcp_oauth_redirect');

  for (const [key, value] of forwardedParams.entries()) {
    relayTarget.searchParams.set(key, value);
  }

  return relayTarget.toString();
}
